import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import Container from '../../Layout/Container'
import DragReveal from '../../components/DragReveal'
import Notice from '../../components/Notice'
import TextHeader from '../../components/TextHeader'

const StyledWrapper = styled.div`
  background: ${({ theme }) => theme.colors.darkBlue};
  color: ${({ theme }) => theme.colors.white};
  padding: 112px 20px 0;
  user-select: none;

  ${({ theme }) => theme.media.desktop} {
    height: 768px;
    padding: 144px 20px 0;
  }
`

const StyledLeftContent = styled.div`
  margin: 0 auto;
  max-width: 335px;
  padding: 20px 0 40px;
  position: relative;
  text-align: center;
  width: 100%;

  sub {
    color: #8a94a6;
    margin-bottom: 16px;
  }

  h3 {
    margin-bottom: 24px;
  }

  a {
    margin: 0 0 24px;
  }

  p {
    color: #697788;
    font-size: 0.75em;
    line-height: 1.67;
  }

  ${({ theme }) => theme.media.desktop} {
    margin: 0;
    max-width: 500px;
    padding: 65px 0 0;
    text-align: left;
    width: 45%;
  }
`

const StyledBottomContent = styled.div`
  height: 74px;
  position: relative;
  z-index: 100;

  ${({ theme }) => theme.media.desktop} {
    margin-bottom: 50px;
    margin-top: 130px;
  }
`

const MainPageHero = ({ mainHeader, bottom, children }) => (
  <StyledWrapper>
    <DragReveal />
    <Container>
      {/*
      <Notice>
        Welcome Email on Acid. <Link to="/blog/welcoming-email-on-acid">Learn more</Link>	
      </Notice>
      */}
      <TextHeader
        mdTitle={mainHeader}
        theme={{
          size: 'big',
          align: 'center',
        }}
      />
      <StyledLeftContent>{children}</StyledLeftContent>
      <StyledBottomContent>{bottom}</StyledBottomContent>
    </Container>
  </StyledWrapper>
)

export default MainPageHero
